export const ventilacionHeroImage =
  "https://readdy.ai/api/search-image?query=Professional%20modern%20mechanical%20ventilation%20system%20in%20an%20industrial%20building%2C%20large%20galvanized%20steel%20HVAC%20ducts%20suspended%20from%20the%20ceiling%20with%20circular%20air%20grilles%20and%20powerful%20extraction%20fans%2C%20clean%20bright%20engineering%20environment%2C%20cool%20steel%20and%20teal%20gray%20tones%2C%20soft%20natural%20lighting%2C%20high%20detail%20editorial%20industrial%20photography%2C%20harmonious%20composition&width=1600&height=800&seq=ventilacion-hero-1&orientation=landscape";

export const ventilacionIntroImage =
  "https://readdy.ai/api/search-image?query=Close%20up%20technical%20detail%20of%20galvanized%20steel%20HVAC%20ductwork%20and%20ventilation%20pipes%20with%20circular%20air%20grilles%20installed%20along%20a%20modern%20commercial%20building%20ceiling%2C%20professional%20mechanical%20engineering%20installation%2C%20clean%20industrial%20environment%2C%20cool%20neutral%20gray%20and%20teal%20tones%2C%20soft%20studio%20lighting%2C%20editorial%20industrial%20photography%2C%20high%20detail&width=900&height=600&seq=ventilacion-intro-1&orientation=landscape";

export const ventilacionServices = [
  {
    title: "RENOVACIÓN DE AIRE",
    description:
      "Sistemas diseñados para ingresar aire fresco y retirar aire viciado de los espacios.",
    icon: "ri-refresh-line",
  },
  {
    title: "EXTRACCIÓN DE AIRE",
    description:
      "Soluciones para eliminar olores, humedad, humo, vapores y contaminantes.",
    icon: "ri-windy-line",
  },
  {
    title: "VENTILACIÓN INDUSTRIAL",
    description:
      "Sistemas adaptados a procesos industriales que requieren control y renovación del aire.",
    icon: "ri-building-2-line",
  },
  {
    title: "VENTILACIÓN PARA COCINAS",
    description:
      "Sistemas de extracción para restaurantes, hoteles, cocinas comerciales e industriales.",
    icon: "ri-restaurant-line",
  },
  {
    title: "EXTRACCIÓN EN BAÑOS Y ZONAS HÚMEDAS",
    description:
      "Soluciones para controlar humedad, olores y mejorar las condiciones ambientales.",
    icon: "ri-drop-line",
  },
  {
    title: "SISTEMAS DE PRESURIZACIÓN",
    description:
      "Diseño de sistemas para controlar presión y circulación del aire en espacios específicos.",
    icon: "ri-dashboard-line",
  },
] as const;

export const ventilacionProcess = [
  {
    step: "01",
    title: "VISITA TÉCNICA",
    description: "Evaluación del espacio y necesidades del proyecto.",
  },
  {
    step: "02",
    title: "DISEÑO",
    description: "Definición del sistema, caudales, equipos y distribución.",
  },
  {
    step: "03",
    title: "INGENIERÍA",
    description: "Desarrollo de planos y especificaciones técnicas.",
  },
  {
    step: "04",
    title: "INSTALACIÓN",
    description: "Montaje de equipos, ductos y componentes.",
  },
  {
    step: "05",
    title: "PUESTA EN MARCHA",
    description: "Pruebas y verificación del correcto funcionamiento.",
  },
] as const;

export const ventilacionBenefits = [
  {
    title: "MEJOR CALIDAD DEL AIRE",
    description: "Favorece la renovación y circulación adecuada del aire.",
    icon: "ri-bubble-chart-line",
  },
  {
    title: "CONFORT",
    description: "Ayuda a mantener condiciones ambientales más agradables.",
    icon: "ri-temp-hot-line",
  },
  {
    title: "EFICIENCIA",
    description:
      "Soluciones diseñadas de acuerdo con las necesidades reales del proyecto.",
    icon: "ri-flashlight-line",
  },
  {
    title: "CONFIABILIDAD",
    description:
      "Sistemas correctamente diseñados, instalados y preparados para su mantenimiento.",
    icon: "ri-shield-check-line",
  },
] as const;

export const ventilacionSectors = [
  {
    name: "Residencial",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20interior%20with%20discreet%20ceiling%20mounted%20air%20ventilation%20grille%20and%20duct%20system%2C%20clean%20bright%20minimalist%20home%20environment%2C%20warm%20natural%20light%20through%20large%20windows%2C%20professional%20interior%20photography%2C%20soft%20teal%20gray%20tones%2C%20high%20detail&width=400&height=300&seq=ventilacion-sector-1&orientation=landscape",
  },
  {
    name: "Comercial",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20commercial%20retail%20store%20interior%20with%20exposed%20industrial%20HVAC%20ventilation%20ducts%20and%20air%20grilles%20along%20the%20ceiling%2C%20clean%20contemporary%20shopping%20space%2C%20bright%20ambient%20lighting%2C%20professional%20architectural%20photography%2C%20teal%20gray%20tones&width=400&height=300&seq=ventilacion-sector-2&orientation=landscape",
  },
  {
    name: "Industrial",
    image:
      "https://readdy.ai/api/search-image?query=Large%20industrial%20factory%20interior%20with%20extensive%20galvanized%20steel%20ventilation%20ductwork%20system%20and%20extraction%20fans%20running%20along%20the%20ceiling%2C%20clean%20manufacturing%20environment%2C%20cool%20industrial%20lighting%2C%20professional%20engineering%20photography%2C%20teal%20gray%20tones&width=400&height=300&seq=ventilacion-sector-3&orientation=landscape",
  },
  {
    name: "Restaurantes y hoteles",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20restaurant%20kitchen%20with%20stainless%20steel%20commercial%20extraction%20hood%20and%20ventilation%20duct%20system%2C%20clean%20modern%20food%20service%20environment%2C%20bright%20hygienic%20lighting%2C%20professional%20hospitality%20photography%2C%20teal%20gray%20tones&width=400&height=300&seq=ventilacion-sector-4&orientation=landscape",
  },
  {
    name: "Oficinas",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20open%20plan%20office%20space%20with%20ceiling%20mounted%20air%20conditioning%20ventilation%20grilles%20and%20ductwork%2C%20clean%20minimalist%20corporate%20interior%2C%20bright%20natural%20daylight%2C%20professional%20architectural%20photography%2C%20teal%20gray%20tones&width=400&height=300&seq=ventilacion-sector-5&orientation=landscape",
  },
  {
    name: "Centros de producción",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20production%20facility%20interior%20with%20industrial%20ventilation%20and%20air%20handling%20ducts%20overhead%2C%20workers%20in%20clean%20uniforms%20below%2C%20modern%20manufacturing%20plant%2C%20bright%20sterile%20lighting%2C%20professional%20industrial%20photography%2C%20teal%20gray%20tones&width=400&height=300&seq=ventilacion-sector-6&orientation=landscape",
  },
] as const;